<template>
  <div class="main_modal" :class="{ activeSide: $store.state.sidebar }">
    <div class="main_modal_crd">
      <div class="modal_top">
        <h1>{{ `${isUpdating ? addTitle : updateTitle}` }}</h1>
        <span @click="$emit('closeModal')">
          <b-icon icon="close" v-if="!disableSubmit"></b-icon>
        </span>
      </div>
      <div class="modal_body">
        <div class="modal_body_part upload_step" v-show="step == 1 && accept">
          <UpoadWidget app="watch.rw" :accept="accept" libraryId="147551" videoId="" :streamServerBaseUrl="baseUrl"
            :showUploadOtherButton="showUploadOtherButton" :canCreate="true" @created="(data) => { }"
            @started="(data) => { onStarted(data) }" @progress="(data) => { onProgress(data) }"
            @completed="(data) => { onComplete(data) }" @reset="onHideProgress()" @error="() => { onError() }"
            :showBackButton="false">
            <div class="upload-widget-wrapper">
              <div class="upload_cover">
                <b-icon icon="upload" size="is-large"></b-icon>
              </div>
              <h1>Drag and drop video files to upload</h1>
              <p>Your videos will be private until you publish them</p>
            </div>
          </UpoadWidget>
        </div>
        <slot></slot>
      </div>
      <div class="modal_footer">
        <div>
          <span v-if="uploadShow">
            <b-icon :icon="uploadLabel.uploadIcon"
              :type="{ 'is-danger': failedUpload, 'is-primary': !failedUpload }"></b-icon> &nbsp;
            {{ uploadLabel.uploadText }}
          </span>
        </div>
        <div class="actions">
          <b-button type="is-primary" outlined @click="stepBackward"
            :disabled="step == 1 || submitLoading || (step == 2 && !isUpdating)" v-if="step_count != 1">BACK</b-button>
          <b-button type="is-primary" @click="stepForward" :disabled="step == step_count"
            v-if="step != step_count">NEXT</b-button>
          <b-button type="is-primary" @click="submit" v-if="step == step_count" :loading="submitLoading"
            :disabled="disableSubmit">SUBMIT</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpoadWidget from '../components/MediaUploadWidget.vue';
import { MEDIA_SERVER_BASE_URL } from "@/store/variables.js"
export default {
  props: {
    isUpdating: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    step_count: {
      type: Number,
      default: 3
    },
    addTitle: {
      type: String,
      default: ''
    },
    updateTitle: {
      type: String,
      default: ''
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ''
    },
    showUploadOtherButton: {
      type: Boolean,
      default: false
    }
  },
  components: { UpoadWidget },
  data() {
    return {
      enableUpload: false,
      uploadLabel: {
        uploadText: '',
        uploadIcon: ''
      },
      uploadShow: false,
      disableSubmit: false,
      failedUpload: false,
      baseUrl: MEDIA_SERVER_BASE_URL
    }
  },
  mounted() {
  },
  methods: {
    onHideProgress() {
      let vm = this;
      vm.uploadShow = false;
    },
    onStarted(data) {
      let vm = this;
      vm.uploadLabel.uploadText = 'Initializing Media Upload...'
      vm.uploadLabel.uploadIcon = 'mdi mdi-progress-clock'
      vm.uploadShow = true;
      // vm.disableSubmit = true;
      vm.failedUpload = false;
      vm.$store.dispatch('ADD_MEDIA_FILE_ID', { mediaId: data.videoId, mediaType: data.fileType, fileName: data.fileName })
        .then((res) => {
          vm.$emit('onFileInit', data.videoId);
          vm.$emit('uploadFinished', false);
          vm.stepForward();
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onProgress(data) {
      let vm = this;
      if (data.type == 'server_upload') {
        vm.uploadLabel.uploadText = ` ${data.label}`
        vm.uploadLabel.uploadIcon = 'mdi mdi-progress-upload'
      } else if (data.type == 'converting_media_progress') {
        vm.uploadLabel.uploadText = `Processing... ${data.percentage}%`
        vm.uploadLabel.uploadIcon = 'mdi mdi-progress-clock'
      } else if (data.type == 'cdn_upload_progress') {
        vm.uploadLabel.uploadText = `Finalizing... ${data.percentage}%`
        vm.uploadLabel.uploadIcon = 'mdi mdi-progress-clock'
      }
    },
    onComplete(data) {
      let vm = this;
      if (data.type == 'cdn_upload') {
        vm.uploadLabel.uploadText = 'Media Is Now Ready!'
        vm.uploadLabel.uploadIcon = 'mdi mdi-check-circle-outline'
        vm.disableSubmit = false;
      } else if (data.type == 'server_upload') {
        vm.$emit('uploadFinished', true);
      }
    },
    onError() {
      let vm = this;
      vm.uploadLabel.uploadText = 'Upload Failed!'
      vm.uploadLabel.uploadIcon = 'mdi mdi-progress-close'
      vm.disableSubmit = false;
      vm.failedUpload = true;
    },
    stepForward() {
      let vm = this;
      vm.$emit('stepForward')
    },
    stepBackward() {
      let vm = this;
      vm.$emit('stepBackward')
    },
    submit() {
      let vm = this;
      vm.$emit('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
.main_modal {
  position: fixed;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.268);
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  align-items: center;
  overflow-y: scroll;
  transition: .8s;
  z-index: 20;

  @media (max-height: 859px) {
    align-items: flex-start;
  }

  @media (max-width: 450px) {
    padding: 0;
  }

  &.activeSide {
    width: calc(100% - 230px);

    @media (max-width: 966px) {
      width: 100%;
    }

    .main_modal_crd {
      .modal_body {
        .modal_body_part {
          &.split_step {
            @media (max-width: 1162px) {
              grid-template-columns: 58% 40%;
            }

            @media (max-width: 768px) {
              grid-template-columns: 100%;
              row-gap: 20px;
            }
          }
        }
      }
    }
  }

  .main_modal_crd {
    width: 90%;
    background: white;
    min-height: 300px;
    height: fit-content;
    border-radius: 10px;
    position: relative;
    overflow: hidden;

    @media (max-width: 580px) {
      width: 95%;
    }

    @media (max-width: 450px) {
      width: 100%;
      border-radius: 0;
      height: calc(100vh - 60px);
    }

    .modal_top {
      display: flex;
      padding: 16px 23px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #dfdfdf;
      position: sticky;
      top: 0;

      h1 {
        font-size: 17px;
        font-weight: 600;
      }

      span {
        cursor: pointer;
      }
    }

    .modal_body {
      height: 550px;
      overflow-y: auto;
      padding: 10px 23px 75px;

      @media (max-width: 580px) {
        padding-bottom: 100px;
      }

      @media (max-width: 450px) {
        padding-bottom: 75px;
        height: 88%;
      }

      .modal_body_part {
        &.upload_step {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;

          .upload-widget-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 20px;
          }

          .upload_cover {
            display: flex;
            width: 90px;
            height: 90px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background: #D9D9D9;
            margin-bottom: 20px;
          }

          h1 {
            font-weight: 600;
            margin-bottom: 5px;
          }

          p {
            opacity: .7;
            text-align: center;
            // margin-bottom: 20px;
          }

          .upload-trigger {
            width: 40%;
            margin-top: 20px;
          }
        }

        &.split_step {
          display: grid;
          grid-template-columns: 68% 30%;
          justify-content: space-between;

          @media (max-width: 1000px) {
            grid-template-columns: 58% 40%;
          }

          @media (max-width: 768px) {
            grid-template-columns: 100%;
            row-gap: 20px;
          }

          .split_part_data {
            h1.title {
              margin-bottom: 15px;
              font-size: 23px;
            }

            .b-field-txt {
              opacity: .6;
              display: flex;

              &.mbottom {
                margin-bottom: 10px;
              }
            }

            .taginput.control {
              display: flex;
            }

            .upload-trigger {
              width: 200px;
            }

            .visibility-grp {
              .visibility-grp-title {
                font-weight: 700;
              }

              .field.has-numberinput {
                width: 200px;
              }

              .field {
                .field-body {
                  .field.has-addons {
                    border: 1px solid red;
                  }
                }
              }

              .visibility-grp-sub {
                opacity: .7;
              }

              .visibility-togglers {
                margin-top: 10px;
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                padding-left: 40px;

                .visibility-togglers-each {
                  h1 {
                    display: flex;
                  }
                }
              }
            }
          }

          .split_part_view {
            .data_cover {
              height: 300px;
              border-radius: 10px;
              overflow: hidden;
              position: relative;
              margin-bottom: 13px;

              .b-skeleton {
                height: 100%;

                .b-skeleton-item {
                  height: 100%;
                }
              }

              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }

              .media {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: white;
                border-radius: 50%;
                cursor: pointer;
                box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);
              }

              .indicator {
                position: absolute;
                bottom: 20px;
                right: 20px;
                background: #6EC492;
                padding: 6px 13px;
                font-size: 15px;
                border-radius: 3px;
                color: white;
              }
            }

            h1.name {
              font-weight: 600;
              font-size: 20px;
              margin-bottom: 13px;
            }

            p.descr {
              font-size: 16px;
              opacity: .7;
              margin-bottom: 15px;
            }

            .spaced-skeleton {
              margin-bottom: 15px;
            }

            .split_data_pt {
              display: flex;
              flex-direction: column;
              row-gap: 10px;

              .split_data_pt_crd {
                display: flex;
                font-size: 15px;

                .split_data_pt_crd_more {
                  margin-left: 5px;

                  .b-skeleton {
                    height: 100%;

                    .b-skeleton-item {
                      width: 200px;
                    }
                  }

                  span {
                    i {
                      display: inline-flex;
                      margin: 0 2px;
                    }

                    &:last-of-type {
                      i {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .modal_footer {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 10px 23px;
      align-items: center;
      background: white;
      z-index: 10;
      border-top: 1px solid #dfdfdf;

      @media (max-width: 580px) {
        flex-direction: column;
        row-gap: 5px;
      }

      span {
        display: flex;
        align-items: center;
      }

      .actions {
        display: flex;
        align-items: center;
        column-gap: 20px;

        @media (max-width: 580px) {
          width: 100%;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>